/**
 * OMNITrade Logo Component
 * Uses the actual logo image file
 */

export const OmniTradeLogo = ({ className = "w-10 h-10" }) => {
  return (
    <img 
      src="/omnitrade-logo.png" 
      alt="OMNITrade Logo" 
      className={className}
    />
  );
};

export const OmniTradeLogoWithText = ({ className = "", variant = "light", size = "default" }) => {
  const textColor = variant === 'dark' ? 'text-white' : 'text-[#1E3A5F]';
  const logoSize = size === 'large' ? 'w-12 h-12' : 'w-8 h-8';
  const textSize = size === 'large' ? 'text-2xl' : 'text-xl';
  
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <OmniTradeLogo className={logoSize} />
      <span 
        className={`font-bold tracking-wide ${textSize} ${textColor}`}
        style={{ fontFamily: "'Helvetica Neue', Arial, sans-serif" }}
      >
        OMNITrade
      </span>
    </div>
  );
};

// Backward compatibility aliases
export const SyncLogo = OmniTradeLogo;
export const SyncLogoWithText = OmniTradeLogoWithText;

export default OmniTradeLogo;
